import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { RawHTML } from "../common";
import Dotdotdot from "react-dotdotdot";
import styles from "./styles.less";
import GalleryPopUp from "../GalleryPopUp";
import PriceDisplay from "../../containers/PriceDisplay";

const imageSrcWithCrop = src => `${src}?w=450&h=300&mode=crop`;

class DealRate extends Component {
  // componentDidUpdate() {
  //   if (this.rateRef && this.imageRef) {
  //     const rate = this.rateRef;
  //     const image = this.imageRef;
  //     const width = rate.scrollWidth;
  //     const height = (width * 3) / 4;
  //     requestAnimationFrame(() => {
  //       image.style.height = height + "px";
  //     });
  //   }
  // }

  createDealRef = ref => (this.rateRef = ref);
  createImageRef = ref => (this.imageRef = ref);

  onClick = () => {
    const {
      onClick,
      rateId,
      priceCode,
      planCode,
      allocationCode,
      roomId
    } = this.props;
    onClick({ rateId, priceCode, planCode, allocationCode, roomId });
  };

  onReadeMoreClick = e => {
    e.preventDefault();
    e.stopPropagation(); // so we won't select the rate (parent element)
    const { onRateReadMore, rateId, roomId } = this.props;
    onRateReadMore({ rateId, roomId });
  };

  showSimpleClubLoginModal = () => {
    const { showSimpleClubLoginModal } = this.props;
    showSimpleClubLoginModal();
  };

  onShowRoomGalleryPopUp = () => {
    const { onShowRoomGalleryPopUp, room } = this.props;
    onShowRoomGalleryPopUp(room);
  };

  renderRate = () => {
    const {
      active,
      planName,
      titleName,
      price,
      isRtl,
      titles,
      isPackage,
      availability,
      lowAvailabilityCount,
      showAvailability,
      showClubPrices,
      ratePriceAfterDiscount,
      oldPrice,
      isIE,
      isMobileView,
      room,
      image
    } = this.props;
    const showMobileGallery = image && isMobileView;
    const showDesktopGallery = image && !isMobileView;
    return (
      <React.Fragment>
        <div
          className={cx(styles.rate, {
            [styles.rtl]: isRtl
          })}
          ref={this.createDealRef}
        >
          <div className={styles.readMoreSaleWrapper}>
            <div className={styles.rateSale}>
              {isPackage ? titles.Sale + "!!!" : ""}
            </div>
            <div
              className={styles.readMore}
              onClick={this.onReadeMoreClick}
              onKeyDown={this.onReadeMoreClick}
              role="button"
              tabIndex="0"
            >
              {titles.RoomDetails}
            </div>
          </div>

          <div
            className={cx(styles.rateBody, {
              [styles.active]: active,
              [styles.rateBodyMobileView]: isMobileView
            })}
          >
            {showDesktopGallery && (
              <div
                className={styles.rateImageWrapper}
                ref={this.createImageRef}
                onClick={this.onShowRoomGalleryPopUp}
                onKeyDown={this.onShowRoomGalleryPopUp}
                role="button"
                tabIndex="0"
              >
                <img
                  src={imageSrcWithCrop(image)}
                  className={styles.rateImage}
                  alt={titleName}
                />
                <span
                  className={cx(
                    styles.icon,
                    `icon-amenetie`,
                    `icon-magnifying-lens-with-plus-sign`
                  )}
                />
              </div>
            )}
            {showMobileGallery && (
              <GalleryPopUp
                room={room}
                showThumbnails={false}
                isRtl={isRtl}
                isMobileView={isMobileView}
              />
            )}
            <div
              className={styles.rateMainContent}
              onClick={!active ? this.onClick : null}
              onKeyDown={this.onClick}
              role="button"
              tabIndex="0"
            >
              <div
                className={cx(styles.dataSection, {
                  [styles.dataSectionRtl]: isRtl
                })}
              >
                <div className={styles.priceNameWrapper}>
                  <div className={cx(styles.priceName)}>
                    <Dotdotdot
                      className={cx({ [styles.ieIsShit]: isIE })}
                      clamp={2}
                    >
                      <RawHTML html={titleName} />
                    </Dotdotdot>
                  </div>
                </div>
                <div
                  className={cx(styles.planName, { [styles.ieIsShit]: isIE })}
                >
                  <RawHTML html={planName} />
                </div>
                {showAvailability && (
                  <div
                    className={cx(styles.availability, {
                      [styles.lowCount]: availability < lowAvailabilityCount
                    })}
                  >
                    <div className={styles.title}>{titles.Availability}</div>
                    <div className={styles.count}>{availability}</div>
                  </div>
                )}
                <div className={styles.pricesWrapper}>
                  <div className={styles.innerPricesWrapper}>
                    <div
                      className={cx(styles.pricesSectionOrig, {
                        [styles.fixedToTheSideRtl]: isRtl
                      })}
                    >
                      {oldPrice > 0 && (
                        <span
                          className={cx(styles.origPrice, {
                            [styles.strikePriceRtl]: isRtl
                          })}
                        >
                          <PriceDisplay
                            price={oldPrice}
                            currentCurrencyCode={room.currencyCode}
                            fallBackCurrencySymbol={room.currency}
                          >
                            {price => price}
                          </PriceDisplay>
                        </span>
                      )}
                      <span
                        className={cx(styles.price, {
                          [styles.strikePrice]: showClubPrices,
                          [styles.strikePriceRtl]: isRtl
                        })}
                      >
                        <PriceDisplay
                          price={price}
                          currentCurrencyCode={room.currencyCode}
                          fallBackCurrencySymbol={room.currency}
                        >
                          {price => price}
                        </PriceDisplay>
                      </span>
                    </div>
                    <div className={styles.rateOrderButton}>
                      {titles.Checkout}
                    </div>
                  </div>
                </div>
                {showClubPrices && (
                  <div className={styles.clubBadgeWrapper}>
                    <div className={styles.clubBadgeContent}>
                      <div className={styles.clubBadgeContentPriceTitle}>
                        {titles.PriceForClubMemeber} &nbsp;
                        <span className={styles.clubBadgeContentPrice}>
                          <PriceDisplay
                            price={ratePriceAfterDiscount}
                            currentCurrencyCode={room.currencyCode}
                            fallBackCurrencySymbol={room.currency}
                          >
                            {price => price}
                          </PriceDisplay>
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    return <React.Fragment>{this.renderRate()}</React.Fragment>;
  }
}

DealRate.propTypes = {
  isRtl: PropTypes.bool,
  titles: PropTypes.object,
  rateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  priceCode: PropTypes.string,
  planCode: PropTypes.string,
  planName: PropTypes.string,
  titleName: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  availability: PropTypes.number,
  allocationCode: PropTypes.string,
  lowAvailabilityCount: PropTypes.number,
  showAvailability: PropTypes.bool,
  active: PropTypes.bool,
  isPackage: PropTypes.bool,
  onClick: PropTypes.func,
  onRateReadMore: PropTypes.func,
  showClubPrices: PropTypes.bool,
  ratePriceAfterDiscount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  isIE: PropTypes.bool,
  image: PropTypes.string,
  roomId: PropTypes.string,
  oldPrice: PropTypes.number,
  showSimpleClubLoginModal: PropTypes.func,
  onShowRoomGalleryPopUp: PropTypes.func,
  isMobileView: PropTypes.bool,
  room: PropTypes.object
};

DealRate.defaultProps = {
  showAvailability: true,
  lowAvailabilityCount: 4,
  titles: {
    ReadMore: "Read More..."
  }
};

export default DealRate;



// WEBPACK FOOTER //
// ./src/components/DealRate/DealRate.js